module.exports = " <div :aria-hidden=\"`${ariaHidden}`\"> <div class=c-dialog-overlay :style=\"{backgroundColor: overlayBackground}\" @click.stop=close v-if=isOpen transition=wv-dialog-overlay tabindex=-1></div> <div class=c-dialog @click.stop=close v-show=isOpen transition=wv-dialog-overlay :aria-labelledby=ariaLabelledby :aria-describedby=ariaDescribedby role=dialog> <div class=c-dialog__content :class=[class] :style=\"{maxWidth: dialogMaxWidth}\" v-el:dialog-content v-show=isOpen @animationend=onTransitionEnd transition=wv-dialog role=document> <slot></slot> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Dialog.vue
 ** module id = 141
 ** module chunks = 1
 **/